class DateHelper {
  static getYyyyMmDdString(date = new Date()) {
    const paddingFillString = '0'
    const month = (date.getMonth() + 1).toString().padStart(2, paddingFillString)
    const day = date.getDate().toString().padStart(2, paddingFillString)

    return [date.getFullYear(), month, day].join('-')
  }
  static previousMonth(date = new Date()) {
    return new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
  }
}
export default DateHelper
